import axios from 'axios';
import { getApplicationAuthApi, getUrlAuthApi, getUrlUserApi, TOKEN_KEY } from '../utils/util';
import { getToken, logout } from './Auth';

export const baseURLAUTH = String(getUrlAuthApi(window))
export const baseURLUser = String(getUrlUserApi(window))
export const ApplicationAuth = String(getApplicationAuthApi(window))
export const ApplicationCode = 'AVISO_EMBARQUE'


export default class UserApi {

    static getUsers() {

        return axios.get(baseURLUser + "/service/security/app/users",
        { 
            headers: { 
                ApplicationAuth: ApplicationAuth,
                ApplicationCode,
            } 
        })
    }

    static getUser(user: any) {
        return axios.post(baseURLAUTH + "/api/usersV1/", {
            username: user.userName,
            password: user.password,
            system: ApplicationCode,
            entity: user.view === undefined || user.view === '' || user.view === null ? "" : user.view
        });
    };

	static getUserMenu(token: string, company: string) {
        return axios.post(baseURLAUTH + "/api/usersV1/usermenu/", {
            token: token,
            system: ApplicationCode,
            entity: company
        }, { timeout: 999999});
    };
    
    static getUserToken(token: string, company: string) {
        return axios.post(baseURLAUTH + "/api/usersV1/permissions/", {
            token: token,
            system: ApplicationCode,
            entity: company === undefined || company === '' || company === null ?  "" : company
        });
    };

    static async refreshToken() {
        const AuthStr = 'Bearer '.concat(getToken() as string);
        axios.get(baseURLAUTH + "/api/usersV1/", { headers: { Authorization: AuthStr } }).then(response => {
            localStorage.setItem(TOKEN_KEY, response.data);
        }).catch((error) => {
            logout();
        });
    }
}
